/**
 * Paths where the full query string may contain secrets (tokens, email, etc.).
 * Analytics pageviews should use pathname only.
 */
const PATHNAMES_STRIP_ALL_QUERY = new Set([
  '/confirm',
  '/reset',
  '/confirm-invite',
]);

const SENSITIVE_QUERY_KEYS = new Set([
  'token',
  'email',
  'code',
  'password',
]);

function normalizePathname(pathname: string): string {
  if (!pathname || pathname === '') {
    return '/';
  }
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

/**
 * Returns a path safe to send to GA / PostHog / Mixpanel (no emails or auth tokens in query).
 */
export function sanitizePathForAnalytics(asPath: string): string {
  if (!asPath || typeof asPath !== 'string') {
    return '/';
  }

  const withoutHash = asPath.split('#')[0];
  const qIndex = withoutHash.indexOf('?');
  const pathnameRaw = qIndex === -1 ? withoutHash : withoutHash.slice(0, qIndex);
  const search = qIndex === -1 ? '' : withoutHash.slice(qIndex + 1);
  const pathname = normalizePathname(pathnameRaw);

  if (PATHNAMES_STRIP_ALL_QUERY.has(pathname)) {
    return pathname;
  }

  if (!search) {
    return pathname;
  }

  const params = new URLSearchParams(search);
  for (const key of [...params.keys()]) {
    if (SENSITIVE_QUERY_KEYS.has(key.toLowerCase())) {
      params.delete(key);
    }
  }

  const next = params.toString();
  return next ? `${pathname}?${next}` : pathname;
}
